/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Tooltip from 'react-bootstrap/Tooltip';

import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

import {
  rebateProgramLabel,
  quarterRangeLabel,
  unallocatedBalanceLabel,
  URAUsedLabel,
  ARSummaryByQtrrLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { ARSummryByQtrColumns } from '../tablehead';
import { getUnallocatedBalanceQtr, getSingleAccRecQtr } from './store/actions';
import * as actiontypes from './store/actiontypes';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { goToArSummaryQtrAccountSingle } from '../ARCommonFunctions';
import { RedTextRenderCompKeyChange } from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  qtrAccRecFieldValues,
  dispatchQARBalanceDue,
  dispatchQAROveridden,
  dispatchQARPaidInFull,
} from '../QtrAccountsRec/store/actions';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const ARSummaryByQtr = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [unallocatedBlnQtr, setUnallocatedBlnQtr] = React.useState(0);
  const [load, setLoad] = React.useState(false);
  const [pinned, setPinned] = React.useState();
  const [ARSummaryQTRTableData, setARSummaryQTRTableData] = React.useState([]);
  const activepgmCode = props?.location?.state?.rebateProgram
    ? props?.location?.state?.rebateProgram
    : props?.location?.value?.state?.rebateProgram;
  const find_ar_smry_qtr_tbl = useSelector((state) =>
    state?.sharedState?.ArSummaryQtrReducer?.ar_smry_qtr_tbl?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const ar_smry_qtr_tbl = find_ar_smry_qtr_tbl?.[activepgmCode];
  const find_qtr_field_value = useSelector((state) =>
    state?.sharedState?.ArSummaryQtrReducer?.qtr_field_value?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const qtr_field_value = find_qtr_field_value?.[activepgmCode];
  const ar_smry_qtr_unallocated = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrReducer?.ar_smry_qtr_unallocated
  );
  const ar_smry_single_qtr_main = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrReducer?.ar_smry_single_qtr_main
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  // get account rec single quarter values from redux
  React.useEffect(() => {
    if (ar_smry_single_qtr_main && ar_smry_single_qtr_main.status === '001') {
      let qtrAccRecFieldData = {
        [activepgmCode]: qtr_field_value,
      };
      dispatch(qtrAccRecFieldValues(qtrAccRecFieldData));
      goToArSummaryQtrAccountSingle(
        props.history,
        qtr_field_value?.pgmCd,
        dispatch
      );
      dispatch({
        type: actiontypes.AR_SMRY_FOR_QTR_SINGLE,
        payload: null,
      });
    }
  }, [ar_smry_single_qtr_main]);
  // get unallocated balance from redux
  React.useEffect(() => {
    if (ar_smry_qtr_unallocated && ar_smry_qtr_unallocated.status === '001') {
      setUnallocatedBlnQtr(ar_smry_qtr_unallocated.unallocatedBalance || 0);
    }
  }, [ar_smry_qtr_unallocated]);
  // get qtr_field_value from redux and call the unallocated api
  React.useEffect(() => {
    if (qtr_field_value?.pgmCd) {
      const payload = {
        rebateProgram: qtr_field_value?.pgmCd,
        indicator: 1,
      };
      dispatch(getUnallocatedBalanceQtr(payload));
    }
  }, [qtr_field_value]);
  const getBgHighlighterColor = (obj) => {
    let bgColor = '';
    if (
      obj.invoiceStatusCd === 'DB' ||
      obj.invoiceStatusCd === 'FG' ||
      obj.invoiceStatusCd === 'WO'
    ) {
      bgColor = 'green-legend';
    } else if (obj.convertedQtrInd === 1) {
      bgColor = 'yellow-legend';
    } else if (obj.actions === 'hide') {
      bgColor = 'd-none';
    }
    return bgColor;
  };
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          currBalance: sum('currBalance'),
          offsetDue: sum('offsetDue'),
          baseStateAmountDue: sum('baseStateAmountDue'),
          baseStatePaidAmount: sum('baseStatePaidAmount'),
          baseStateRebateAmt: sum('baseStateRebateAmt'),
          interestPaid: sum('interestPaid'),
          interestDue: sum('interestDue'),
          disputeAmt: sum('disputeAmt'),
          revisedReimburseAmt: sum('revisedReimburseAmt'),
          totalDue: sum('totalDue'),
          currInvAMt: sum('currInvAMt'),
          currRoa: sum('currRoa'),
          amtPaid: sum('amtPaid'),
          offsetPaidAmt: sum('offsetPaidAmt'),
          origInvAMt: sum('origInvAMt'),
          disputeCount: sum('disputeCount'),
          invoices: sum('invoices'),
          quarter: 'Total:',
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    } else {
      const data = [
        {
          currBalance: ar_smry_qtr_tbl?.totalCurrBalance,
          offsetDue: ar_smry_qtr_tbl?.totalOffsetDue,
          baseStateAmountDue: ar_smry_qtr_tbl?.totalBaseStateAmountDue,
          baseStatePaidAmount: ar_smry_qtr_tbl?.totalBaseStatePaidAmount,
          baseStateRebateAmt: ar_smry_qtr_tbl?.totalBaseStateRebateAmount,
          interestPaid: ar_smry_qtr_tbl?.totalInterestPaid,
          interestDue: ar_smry_qtr_tbl?.totalInterestDue,
          disputeAmt: ar_smry_qtr_tbl?.totalDisputeAmt,
          revisedReimburseAmt: ar_smry_qtr_tbl?.totalRevisedReimburseAmt,
          totalDue: ar_smry_qtr_tbl?.finalTotalDue,
          currInvAMt: ar_smry_qtr_tbl?.totalCurrInvAMt,
          currRoa: ar_smry_qtr_tbl?.totalCurrRoa,
          amtPaid: ar_smry_qtr_tbl?.totalAmtPaid,
          offsetPaidAmt: ar_smry_qtr_tbl?.totalOffsetPaidAmt,
          origInvAMt: ar_smry_qtr_tbl?.totalOrigInvAMt,
          disputeCount: ar_smry_qtr_tbl?.totalDisputeCount,
          invoices: ar_smry_qtr_tbl?.totalInvoices,
          quarter: 'Total:',
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    }
  }, [filterApply, filteredRows]);
  React.useEffect(() => {
    const filterPDFData = ar_smry_qtr_tbl?.acctRecvbyQtrForAllQtrsInfo.map(
      (obj) => {
        obj.bgHighlighterColor = getBgHighlighterColor(obj);
        return obj;
      }
    );
    setARSummaryQTRTableData(filterPDFData);
  }, [ar_smry_qtr_tbl]);
  // redirect Go to quarter account receivable page
  const handleGoToQtrAccRec = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        rebateProgram: qtr_field_value?.pgmCd,
        quarter: row.quarter,
        userOfficialUra: qtr_field_value?.uraInfo === 'Official' ? 1 : 0,
      };
      dispatch(getSingleAccRecQtr(payload));
      if (UserDefaultValues) {
        if (UserDefaultValues?.dispBalanceDueInvInd != 0) {
          dispatch(
            dispatchQARBalanceDue({
              [payload.rebateProgram]: true,
            })
          );
        } else {
          dispatch(
            dispatchQARBalanceDue({
              [payload.rebateProgram]: false,
            })
          );
        }
        if (UserDefaultValues?.dispOverriddenInvInd != 0) {
          dispatch(
            dispatchQAROveridden({
              [payload.rebateProgram]: true,
            })
          );
        } else {
          dispatch(
            dispatchQAROveridden({
              [payload.rebateProgram]: false,
            })
          );
        }
        if (UserDefaultValues?.dispPaidInFullInvInd != 0) {
          dispatch(
            dispatchQARPaidInFull({
              [payload.rebateProgram]: true,
            })
          );
        } else {
          dispatch(
            dispatchQARPaidInFull({
              [payload.rebateProgram]: false,
            })
          );
        }
      } else {
        dispatch(
          dispatchQARBalanceDue({
            [payload.rebateProgram]: true,
          })
        );
        dispatch(
          dispatchQAROveridden({
            [payload.rebateProgram]: true,
          })
        );
        dispatch(
          dispatchQARPaidInFull({
            [payload.rebateProgram]: false,
          })
        );
      }
    }
  };
  // ag-grid frame work component
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      return (
        <div className="tdCell dib icon-btn-group" data-testid="action-column">
          <Dropdown className="icon-dropdown-container">
            <Dropdown.Toggle
              className="icon-dropdown export_wrap"
              aria-label="export"
            >
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
              >
                <SVGComponent iconName="Icon-export1" />
              </OverlayTrigger>
            </Dropdown.Toggle>
            <Dropdown.Menu className="export_dropdown">
              <Dropdown.Item
                role="button"
                onClick={() => handleGoToQtrAccRec(cellInfo?.data)}
              >
                Go To Quarterly Accounts Receivable
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    },
    NameTextRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return cellInfo.value;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
  };

  const renderTooltip = (propsTooltip) => {
    return qtr_field_value?.qtrInfo.indexOf('DRAMS') !== -1 ||
      qtr_field_value?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {qtr_field_value?.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  // ongrid ready function
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  let thirdInfo = `Rebate Program: ${qtr_field_value?.pgmInfo}`;
  let fourthInfo = `Quarter Range: ${qtr_field_value?.qtrInfo}`;
  let firstInfo = `Unallocated Balance: ${
    unallocatedBlnQtr < 0
      ? `(${formatter.format(-unallocatedBlnQtr).replace(/^(\D+)/, '$1 ')})`
      : `${formatter.format(unallocatedBlnQtr).replace(/^(\D+)/, '$1 ')}`
  }`;
  let secondInfo = `URA Used: ${qtr_field_value?.uraInfo}`;

  return (
    <div className="tabs-container" data-testid="ARSummaryByQtr">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2={`AR Summary By Qtr [${qtr_field_value?.pgmCd}]`}
      />
      <div className="row">
        {!fullScreenView && (
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={qtr_field_value?.pgmInfo}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <TextField
                        id="quarter"
                        label={quarterRangeLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          qtr_field_value?.qtrInfo.indexOf('DRAMS') !== -1 ||
                          qtr_field_value?.qtrInfo.indexOf('First') !== -1
                            ? `${qtr_field_value?.qtrInfo?.substring(0, 20)}...`
                            : qtr_field_value?.qtrInfo
                        }
                      />
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="unallocatedBalance"
                      label={unallocatedBalanceLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      className={unallocatedBlnQtr < 0 ? 'negative-value' : ''}
                      value={`${
                        unallocatedBlnQtr < 0
                          ? `(${formatter
                              .format(-unallocatedBlnQtr)
                              .replace(/^(\D+)/, '$1 ')})`
                          : `${formatter
                              .format(unallocatedBlnQtr)
                              .replace(/^(\D+)/, '$1 ')}`
                      } `}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={qtr_field_value?.uraInfo}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell frr-yellow-bg-height bottom-pinned-bold">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={ARSummryByQtrColumns}
            rowData={
              ARSummaryQTRTableData?.map((item) => {
                item.currBalance = item.currBalance
                  ? item.currBalance
                  : parseFloat(0).toFixed(2);
                item.offsetDue = item.offsetDue
                  ? item.offsetDue
                  : parseFloat(0).toFixed(2);
                item.baseStateAmountDue = item.baseStateAmountDue
                  ? item.baseStateAmountDue
                  : parseFloat(0).toFixed(2);
                item.interestDue = item.interestDue
                  ? item.interestDue
                  : parseFloat(0).toFixed(2);
                item.totalDue = item.totalDue
                  ? item.totalDue
                  : parseFloat(0).toFixed(2);
                item.amtPaid = item.amtPaid
                  ? item.amtPaid
                  : parseFloat(0).toFixed(2);
                item.offsetPaidAmt = item.offsetPaidAmt
                  ? item.offsetPaidAmt
                  : parseFloat(0).toFixed(2);
                item.baseStatePaidAmount = item.baseStatePaidAmount
                  ? item.baseStatePaidAmount
                  : parseFloat(0).toFixed(2);
                item.interestPaid = item.interestPaid
                  ? item.interestPaid
                  : parseFloat(0).toFixed(2);
                item.currInvAMt = item.currInvAMt
                  ? item.currInvAMt
                  : parseFloat(0).toFixed(2);
                item.currRoa = item.currRoa
                  ? item.currRoa
                  : parseFloat(0).toFixed(2);
                item.baseStateRebateAmt = item.baseStateRebateAmt
                  ? item.baseStateRebateAmt
                  : parseFloat(0).toFixed(2);
                item.origInvAMt = item.origInvAMt
                  ? item.origInvAMt
                  : parseFloat(0).toFixed(2);

                return item;
              }) || []
            }
            pinnedBottomRowData={
              ar_smry_qtr_tbl?.acctRecvbyQtrForAllQtrsInfo?.length > 0
                ? pinned
                : undefined
            }
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
            }}
            noGlobalSort
            hideColumnsInPdf={['actions']}
            exportFile
            animateRows
            isScrollOn
            sideBar={false}
            fileName={ARSummaryByQtrrLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
    </div>
  );
};

export default ARSummaryByQtr;
